export const selectRating = state => state.review.rating;
export const selectReview = state => state.review.review;
